import { render } from "./AboutUs.vue?vue&type=template&id=1187bddb&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Aboutus.css?vue&type=style&index=1&id=1187bddb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1187bddb"]])

export default __exports__